export interface UserProfileMenuItem {
  id: string;
  label: string;
  icon: string;
  href: string;
}

export const menuItems: UserProfileMenuItem[] = [
  {
    id: "wishlist",
    label: "Wishlist",
    icon: "icons/wishlist_icon.svg",
    href: "/wishlist/",
  },
  {
    id: "quotes",
    label: "Quotes",
    icon: "icons/quotes_icon.svg",
    href: `${process.env.NEXT_PUBLIC_FRONTEND_HOST || ""}/my-quotes/`,
  },
  {
    id: "bookings",
    label: "Bookings",
    icon: "icons/bookings_icon.svg",
    href: `${process.env.NEXT_PUBLIC_FRONTEND_HOST || ""}/my-booking/`,
  },
  {
    id: "referral",
    label: "Referral",
    icon: "icons/referral.svg",
    href: "https://acko.ref-r.com/",
  },
];

export const defaultUserData = {
  name: "Sara Benjamin",
  phone: "9535714175",
  completionPercentage: 100,
  avatar: "S",
};
